import { TextInputField } from 'components/Form/TextInputField'
import Styles from '../../../BlogMetadata.module.scss'

interface SlugFieldProps {
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const SlugField: React.FC<SlugFieldProps> = ({ value, onChange }) => (
  <TextInputField
    wrapperClassName={Styles.inputField}
    label="URL Slug"
    value={value}
    onChange={onChange}
    size="lg"
    labelClassName={Styles.textFieldLabel}
  />
)
